module.exports = __webpack_public_path__ + "static/media/38.93118548.jpg";